import Prestation, { IPrestation } from "@/model/Prestation"
import hasServiceContent, { IHasServiceContent } from "@/model/mixins/Content/hasServiceContent"
import hasServiceFamily, { IHasServiceFamily } from "@/model/mixins/ServiceFamily/hasServiceFamily"
import hasBaseServiceQuoteObject, { IHasBaseServiceQuoteObject } from "@/model/mixins/hasBaseServiceQuoteObject"

class ServiceBase extends Prestation {

    constructor(
        id: string,
        quantity?: number,
        startDate?: string,
        endDate?: string,
    ) {
        super(
            id,
            quantity,
            startDate,
            endDate,
        )
    }

}

export interface IService extends ServiceBase, IPrestation, IHasServiceContent, IHasBaseServiceQuoteObject, IHasServiceFamily { }

// apply mixins
const Service: Constructor<IService> = hasBaseServiceQuoteObject(hasServiceFamily(hasServiceContent(ServiceBase)))

export default Service